// Reglas puras del correo del paso 01: formato, tipo y si deja continuar.
import type { EmailKind, WizardSession } from './types';

/** Formato mínimo antes de habilitar «Enviar código»; el silo lo valida de nuevo. */
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** Lo único que el buró (Modelias) acepta antes de la @: letras (con ñ), dígitos, punto, guion y guion bajo. */
export const EMAIL_LOCAL_PART_PATTERN = /^[\p{L}\p{N}._-]+$/u;

/** Tipos de correo; Personal va primero porque viene preseleccionado. */
export const EMAIL_KIND_OPTIONS: { value: EmailKind; label: string }[] = [
    { value: 'PERSONAL', label: 'Personal' },
    { value: 'CORPORATE', label: 'Corporativo' },
];

export function isEmailFormatValid(value: string): boolean {
    return EMAIL_FORMAT.test(value.trim());
}

/** ¿Lo que va antes de la @ (o todo, si aún no hay @) pasa el filtro del buró? Vacío lo cubre el formato. */
export function isEmailLocalPartAccepted(value: string): boolean {
    const trimmed = value.trim();
    const at = trimmed.lastIndexOf('@');
    const localPart = at === -1 ? trimmed : trimmed.slice(0, at);
    return localPart === '' || EMAIL_LOCAL_PART_PATTERN.test(localPart);
}

/** `PERSONAL` → «Personal»; sin tipo, sin etiqueta. */
export function emailKindLabel(kind: EmailKind | undefined): string | undefined {
    return EMAIL_KIND_OPTIONS.find((option) => option.value === kind)?.label;
}

/** ¿El correo deja continuar? La venta que aceptó términos antes del correo no se bloquea. */
export function emailSettled(session: Pick<WizardSession, 'email' | 'consentsAccepted'>): boolean {
    if (!session.email) return session.consentsAccepted;
    return session.email.state !== 'PENDING';
}
